import { gql } from "apollo-angular";

export const BuyMovFragmentDoc = gql`
  fragment BuyMov on BuyMov {
    id
    status
    updatedAt
    buyDate
    valuePoint
    phoneDelivery
    employee {
      id
      name
      email
      re
    }
    buyItems {
      id
      quantity
      value
      award {
        id
        name
        category
      }
    }
  }
`;

export const GetAllBuyMovDocument = gql`
  query GetAllBuyMov($data: SearchBuyMovInput!) {
    getAllBuyMov(data: $data) {
      ...BuyMov
    }
  }
  ${BuyMovFragmentDoc}
`;

export const UpdateBuyMovDocument = gql`
  mutation UpdateBuyMov($id: String!, $data: UpdateBuyMovInput!) {
    updateBuyMov(id: $id, data: $data) {
      id
      status
    }
  }
`;

export const DischargeBuyMovDocument = gql`
  mutation dischargeBuyMov($buyMovId: String!) {
    dischargeBuyMov(buyMovId: $buyMovId) {
      id
      status
      buyItems {
        id
        quantity
        value
      }
    }
  }
`;

export const RemoveBuyMov = gql`
  mutation removeBuyMov($buyMovId: String!) {
    removeBuyMov(buyMovId: $buyMovId) {
      id
      status
      buyItems {
        id
        quantity
      }
      employee {
        id
        wallet {
          value
        }
      }
    }
  }
`;

export const SearchBuyDocument = gql`
  query SearchBuy($input: SearchBuyInput!) {
    searchBuy(data: $input) {
      ...Buy
    }
  }
  ${BuyMovFragmentDoc}
`;
